import React from 'react';
import { NavLink as ReactNavLink } from 'react-router-dom';
import { NavItem, NavLink } from 'reactstrap';
import UserContext from './../shared/components/user-context/UserContext';
import {PermissionType} from './../shared/components/user-context/models/PermissionType';

import './NavMenu.css';
import { useTranslation } from 'react-i18next';
import { NLP_PATH } from '../AppConstants';

const NavMenu = () => {
    const { t } = useTranslation();
    return (
        <ul className="navmenu-container" tabIndex={0}>
            <div className="logo">
                <span className="logo__title"></span>
                <hr/>
            </div>
            <NavItem>
                <UserContext permission={PermissionType.Contacts_Manage}>
                    <NavLink tag={ReactNavLink} to={"/contacts"} className="navmenu__link" tabIndex={0}>
                        <img
                            alt=""
                            className="navmenu__link-img"
                            src={require("../shared/images/contacts.svg").default} />
                        {t('common.contacts')}
                    </NavLink>
                </UserContext>
                <UserContext permission={[PermissionType.Chats_ManageOwnChats, PermissionType.Chats_ManageOthersChats]}>
                    <NavLink tag={ReactNavLink} to={"/chats"} className="navmenu__link" tabIndex={0}>
                    <img
                        alt=""
                        className="navmenu__link-img"
                        src={require("../shared/images/chats.svg").default} />
                        {t('common.chats')}
                </NavLink>
                </UserContext>
                <UserContext permission={PermissionType.Mailing_Manage}>
                    <NavLink tag={ReactNavLink} to={"/mailing"} className="navmenu__link" tabIndex={0}>
                        <img
                            alt=""
                            className="navmenu__link-img"
                            src={require("../shared/images/mailing.svg").default} />
                        {t('common.mailing')}
                    </NavLink>
                </UserContext>
                <UserContext permission={[PermissionType.NLP_Manage, PermissionType.NLP_Search]}>
                    <NavLink tag={ReactNavLink} to={NLP_PATH} className="navmenu__link" tabIndex={0}>
                        <img
                            alt=""
                            className="navmenu__link-img"
                            src={require("../shared/images/nlp.svg").default} />
                        NLU
                    </NavLink>
                </UserContext>
                <UserContext permission={PermissionType.Operators_Manage}>
                    <NavLink tag={ReactNavLink} to={"/operators"} className="navmenu__link" tabIndex={0}>
                        <img
                            alt=""
                            className="navmenu__link-img"
                            src={require("../shared/images/operators.svg").default} />
                        {t('common.operators')}
                    </NavLink>
                </UserContext>
                <UserContext permission={PermissionType.Channels_Manage}>
                    <NavLink tag={ReactNavLink} to={"/channels"} className="navmenu__link" tabIndex={0}>
                        <img
                            alt=""
                            className="navmenu__link-img"
                            src={require("../shared/images/channels.svg").default} />
                        {t('common.channels')}
                    </NavLink>
                </UserContext>
                <UserContext permission={PermissionType.Integrations_Manage}>
                    <NavLink tag={ReactNavLink} to={"/settings"} className="navmenu__link" tabIndex={0}>
                        <img
                            alt=""
                            className="navmenu__link-img rounded"
                            src={require("../shared/images/settings.svg").default}/>
                        {t('common.settings')}
                    </NavLink>
                </UserContext>
                <UserContext permission={PermissionType.Permission_Manage}>
                    <NavLink tag={ReactNavLink} to={"/permission"} className="navmenu__link" tabIndex={0}>
                        <img
                            alt=""
                            className="navmenu__link-img rounded"
                            src={require("../shared/images/permission.svg").default}/>
                        {t('common.permissions')}
                    </NavLink>
                </UserContext>
                <UserContext permission={PermissionType.Audit_Manage}>
                    <NavLink tag={ReactNavLink} to={"/audit"} className="navmenu__link" tabIndex={0}>
                        <img
                            alt=""
                            className="navmenu__link-img rounded"
                            src={require("../shared/images/audit.svg").default} />
                        {t('common.audit')}
                    </NavLink>
                </UserContext>
                <UserContext permission={PermissionType.CanManageAnalytics}>
                    <NavLink tag={ReactNavLink} to={"/analytics"} className="navmenu__link" tabIndex={0}>
                        <img
                            alt=""
                            className="navmenu__link-img rounded"
                            src={require("../shared/images/analytics.svg").default}/>
                        {t('common.analytics')}
                    </NavLink>
                </UserContext>
                <UserContext permission={PermissionType.License_Manage}>
                    <NavLink tag={ReactNavLink} to={"/license"} className="navmenu__link" tabIndex={0}>
                        <img
                            alt=""
                            className="navmenu__link-img rounded"
                            src={require("../shared/images/license.svg").default}/>
                        {t('license.license')}
                    </NavLink>
                </UserContext>
            </NavItem>
        </ul>
    )
}

export default NavMenu;